// ─── Backend Configuration ───────────────────────────────────────────────────
// Change this single value when deploying to a remote server.
// e.g. 'https://api.mysite.com'
const API_BASE_URL = 'https://nolanx-b.vercel.app';

export default API_BASE_URL;
